import { request } from "../main.top";

/**
 *
 * @param {Number} currentPost
 * @param {{key: String, value: String, compare: ('='|'!=')}[]} metaQueries
 *
 * @returns Promise
 */
export function getRelevantFacts(currentPost = null, tax_queries = [], year = null, page = null) {
    let reqBody = {
        action: "getRelevantFacts",
        tax_query: JSON.stringify(tax_queries),
    };

    if (currentPost) reqBody["post_not_in"] = currentPost;
    if (year) reqBody["year"] = year;
    if (page) reqBody[PAGE] = page;

    return new Promise((success, fail) => {
        request("POST", ajaxurl, reqBody, function (data) {
            success(JSON.parse(data));
        });
    });
}
/**
 *
 * @param {keyof HTMLElementTagNameMap} type Type of the element.
 */
function newElement(type) {
    return document.createElement(type);
}
/**
 * ######################
 * Relevant Facts
 * ######################
 */

const PAGE = "page";

/**
 *
 * @param {HTMLTableElement} factsContainer
 * @param {HTMLSelectElement} yearsField
 * @param {HTMLSelectElement} companyField
 * @param {HTMLElement} paginationContainer
 */
function relevantFactsArchiveInit(factsContainer, yearsField, companyField, paginationContainer) {
    var tax_queries = [];
    if (companyField.value !== "all") {
        tax_queries.push({
            taxonomy: "company",
            field: "slug",
            terms: companyField.value,
        });
    }

    let currentPage = 1;
    let currentPagesAmount = 0;
    let maxItems = 6;
    let pagesContainer = paginationContainer.querySelector(".pages");

    let pageInput = document.createElement("input");
    pageInput.setAttribute("type", "hidden");
    pageInput.setAttribute("id", "page");
    pageInput.setAttribute("value", "1");

    pagesContainer = document.createElement("div");
    pagesContainer.id = "pagesContainer";
    pagesContainer.className = "pages";

    let prevButton = document.createElement("button");
    prevButton.className = "prev";
    prevButton.addEventListener(
        "click",
        () => {
            toPage(prevButton.getAttribute("page"));
        },
        true
    );
    prevButton.setAttribute("page", "prev");

    let nextButton = document.createElement("button");
    nextButton.className = "next";
    nextButton.addEventListener(
        "click",
        () => {
            toPage(nextButton.getAttribute("page"));
        },
        true
    );
    nextButton.setAttribute("page", "next");

    paginationContainer.appendChild(pagesContainer);
    paginationContainer.insertBefore(prevButton, pagesContainer);
    paginationContainer.insertBefore(nextButton, pagesContainer.nextSibling);

    function toPage(pageNumber) {
        if (!pageNumber) return;

        if (pageNumber === "prev") {
            currentPage = currentPage > 1 ? currentPage - 1 : 1;
        } else if (pageNumber === "next") {
            currentPage = currentPage < currentPagesAmount ? currentPage + 1 : currentPagesAmount;
        } else {
            if (currentPage == pageNumber || typeof pageNumber === undefined) return;

            currentPage = parseInt(pageNumber);
        }

        updatePagination(currentPagesAmount);
        getRelevantFacts(null, tax_queries, yearsField.value, currentPage).then((data) => {
            fillRelevantFacts(data);
        });
    }

    function updatePagination(pages) {
        currentPagesAmount = pages;
        if (pages <= 1) {
            paginationContainer.classList.add("empty");
            return;
        } else {
            paginationContainer.classList.remove("empty");
        }

        pagesContainer.innerHTML = "";

        let start = currentPage - maxItems / 2 + 1;
        if (start <= 2) {
            start = 1;
        } else if (start > pages - maxItems + 2) {
            start = pages - maxItems + 2;
        }

        let finish = start + maxItems - 2;
        if (finish > pages - 2) {
            finish = pages;
        }

        if (start >= 3) {
            let more = newElement("span");
            more.innerHTML = "...";

            let button = newElement("button");
            button.setAttribute("page", "1");
            button.addEventListener(
                "click",
                () => {
                    toPage(button.getAttribute("page"));
                },
                true
            );
            button.innerHTML = 1;

            pagesContainer.appendChild(button);
            pagesContainer.appendChild(more);
        }

        for (let i = start; i <= finish; i++) {
            let button = newElement("button");
            button.addEventListener(
                "click",
                () => {
                    toPage(button.getAttribute("page"));
                },
                true
            );
            button.setAttribute("page", i);
            button.innerHTML = i;

            if (currentPage == i) {
                button.className += "active";
            }

            pagesContainer.appendChild(button);
        }

        if (finish <= pages - 2) {
            let more = newElement("span");
            more.innerHTML = "...";

            let button = newElement("button");
            button.setAttribute("page", pages);
            button.addEventListener(
                "click",
                () => {
                    toPage(button.getAttribute("page"));
                },
                true
            );
            button.innerHTML = pages;

            pagesContainer.appendChild(more);
            pagesContainer.appendChild(button);
        }

        if (currentPage <= 1) {
            prevButton.classList.add("disabled");
        } else {
            prevButton.classList.remove("disabled");
        }

        if (currentPage >= pages) {
            nextButton.classList.add("disabled");
        } else {
            nextButton.classList.remove("disabled");
        }
    }

    function fillRelevantFacts(data) {
        let facts = data.posts;
        let years = data.years;
        let pages = data.pages;

        factsContainer.tBodies[0].innerHTML = "";

        if (document.querySelector("span.noItems")) {
            document.querySelector("span.noItems").remove();
        }

        if (facts.length === 0) {
            if (!years) {
                var noFactsElement = document.createElement("span");
                noFactsElement.innerHTML = noItems;
                noFactsElement.className = "noItems";

                factsContainer.appendChild(noFactsElement);
            }
        } else {
            facts.forEach(function (fact, i) {
                let date = new Date(fact.date);
                let dateFormated = date.toLocaleString(lang, { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" });

                let newRow = factsContainer.tBodies[0].insertRow();

                let nameElement = newRow.insertCell();
                nameElement.classList.add("company");
                if (fact.company) {
                    nameElement.innerHTML = `
                        <span class="shortName">${fact.company.shortName}</span>
                        <span class="fullName">${fact.company.fullName}</span>
                        <span class="mobileDate">${dateFormated}</span>
                    `;
                }

                let factTitle = newRow.insertCell();
                factTitle.classList.add("title");
                factTitle.innerHTML = `<a href="${fact.permalink}">${fact.title}</a>`;

                let dateElement = newRow.insertCell();
                dateElement.classList.add("date");
                dateElement.innerHTML = dateFormated;
            });
        }

        // Fill years field
        if (yearsField.innerHTML == "" && years) {
            years.forEach(function (year, i) {
                let option = document.createElement("option");
                option.value = year;
                option.innerHTML = year;

                yearsField.add(option);
            });
        }

        if (facts.length === 0 && years) {
            let changeEvent = new Event("change");
            yearsField.dispatchEvent(changeEvent);
        }

        updatePagination(pages);
    }

    getRelevantFacts(null, tax_queries).then((data) => {
        fillRelevantFacts(data, factsContainer, yearsField, paginationContainer);
    });

    companyField.addEventListener("change", (e) => {
        currentPage = 1;

        if (companyField.value === "all") {
            tax_queries = [];
            // yearsField.classList.remove("d-none");
        } else {
            tax_queries = [
                {
                    taxonomy: "company",
                    terms: companyField.value,
                },
            ];
            // yearsField.classList.add("d-none");
        }

        yearsField.innerHTML = "";

        getRelevantFacts(null, tax_queries).then((data) => {
            fillRelevantFacts(data);
        });
    });

    yearsField.addEventListener("change", (e) => {
        currentPage = 1;

        getRelevantFacts(null, tax_queries, yearsField.value).then((data) => {
            fillRelevantFacts(data);
        });
    });
}

// document.addEventListener("DOMContentLoaded", function () {
setTimeout(() => {
    const factsContainer = document.getElementById("factsContainer");
    const yearsFilter = document.getElementById("years");
    const companiesFilter = document.getElementById("companiesFilter");
    const pagination = document.getElementById("factsPagination");

    if (!(factsContainer && yearsFilter && companiesFilter && pagination)) return;
    relevantFactsArchiveInit(factsContainer, yearsFilter, companiesFilter, pagination);
}, 2000);
// });
